import RecognizedRibbon from '../../src/legacy/RecognizedRibbon.tsx';
export default RecognizedRibbon;
